import React from 'react';

type ContainerVariant = 'default' | 'tight' | 'relaxed' | 'none';
type ContainerSize = 'small' | 'medium' | 'large';

interface ContainerProps {
  children: React.ReactNode;
  variant?: ContainerVariant;
  size?: ContainerSize;
  className?: string;
  as?: 'div' | 'section' | 'article';
}

const sizeClasses = {
  small: {
    padding: '~p-2/3',
    gap: '~gap-2/3',
    horizontal: '~px-2/3',
    vertical: '~py-2/3'
  },
  medium: {
    padding: '~p-3/4',
    gap: '~gap-4/6',
    horizontal: '~px-3/4',
    vertical: '~py-3/4'
  },
  large: {
    padding: '~p-4/6',
    gap: '~gap-6/8',
    horizontal: '~px-4/6',
    vertical: '~py-4/6'
  }
};

const Container: React.FC<ContainerProps> = ({
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  as = 'div'
}) => {
  let relaxedPadding = '';
  if (size === 'small') {
    relaxedPadding = '~p-3/4';
  } else if (size === 'medium') {
    relaxedPadding = '~p-4/6';
  } else {
    relaxedPadding = '~p-5/8';
  }

  const variantPadding = {
    default: sizeClasses[size].padding,
    tight: '~p-1.5/2',
    relaxed: relaxedPadding,
    none: 'p-0'
  };

  const paddingClass = variantPadding[variant];
  const Component = as;

  return (
    <Component className={`w-full ${paddingClass} ${className}`}>
      {children}
    </Component>
  );
};

export const getContainerPaddingClasses = (size: ContainerSize) => {
  return sizeClasses[size];
};

export type { ContainerSize, ContainerVariant };

export default Container;
